import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/administration/filial-connection',
    name: RouteName.AdministrationFilialConnection,
    component: () => import('@/pages/Administration/FilialConnection/Index.vue'),
    meta: {
      permissions: [CRMPermission.ViewAdministrationFilials],
      breadcrumb: {
        label: 'Подключение филиалов',
        parent: RouteName.Administration,
      },
    },
  },
  {
    path: '/administration/filial-connection/:id',
    name: RouteName.AdministrationFilialConnectionCard,
    component: () => import('@/pages/Administration/FilialConnection/Card.vue'),
    meta: {
      permissions: [CRMPermission.ViewAdministrationFilials],
      breadcrumb: {
        label: 'Подключение филиала',
        parent: RouteName.AdministrationFilialConnection,
      },
    },
  },
]
